import React, { useState, useEffect } from 'react'
import { GetSites } from '../../services/sites/sites'
import CustomSelect from './CustomSelect'
import { error, success } from '../../constants/msg'
import { FIELD } from '../../constants/app-constants'
import { recent_events_options } from '../../utils/constants'

const CustomRecentEventSelect = (props) => {
    return (
        <CustomSelect
            {...props}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
            isLoading={false}
            isClearable={props.isClearable}
            options={recent_events_options}
        />
    )
}

export default CustomRecentEventSelect